<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="48" height="48" rx="24" fill="#F9F2FF" />
	<path
		d="M17.3333 18.6668H30.6667M17.3333 24.0002H22.6667M24 34.6668L18.6667 29.3335H14.6667C13.9594 29.3335 13.2811 29.0525 12.781 28.5524C12.281 28.0523 12 27.3741 12 26.6668V16.0002C12 15.2929 12.281 14.6146 12.781 14.1145C13.2811 13.6144 13.9594 13.3335 14.6667 13.3335H33.3333C34.0406 13.3335 34.7189 13.6144 35.219 14.1145C35.719 14.6146 36 15.2929 36 16.0002V26.6668C36 27.3741 35.719 28.0523 35.219 28.5524C34.7189 29.0525 34.0406 29.3335 33.3333 29.3335H29.3333L24 34.6668Z"
		stroke="#8F00FF"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
